// src/components/AIMito/fetchPromptData.ts
import { getIntent } from './queryIntent';
import { INTENT_SOURCES } from './intentConfig';

export async function fetchPromptData(prompt: string) {
  const intent = getIntent(prompt);
  if (!intent) return { status: 'idle' as const };

  const spec = INTENT_SOURCES[intent.type];
  if (!spec) return { status: 'error' as const, error: 'Not supported yet.' };

  try {
    const dataArr = await spec.fetch();
    return {
      status: 'success' as const,
      payload: spec.format(dataArr, intent.wantCountOnly),
    };
  } catch (e: any) {
    return {
      status: 'error' as const,
      error: e?.data?.message || 'Load failed.',
    };
  }
}
